// Single source of truth for the ElevenLabs assistant status presentation,
// shared by the HTML control (ElevenLabsButton) and the in-VR panel (ElevenLabsVR).
export const ELEVENLABS_STATUS = {
  idle: { color: "#000000", label: "Hablemos", pulso: false },
  connecting: { color: "#f59e0b", label: "Conectando...", pulso: false },
  connected: { color: "#ef4444", label: "Colgar", pulso: true },
};
